import React from 'react'
import styled from 'styled-components'

import TripTile from './TripTile'

import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { verticalChildSpacing } from 'components/utils/spacing'
import { BasicTrip } from 'tripPlanner/types/common'

const TextSection = styled.div`
  ${verticalChildSpacing[8]}

  ${mediaQueryUp.sm} {
    flex: 2;
  }
`

const TileSection = styled.div`
  ${mediaQueryUp.sm} {
    flex: 3;
  }
`

interface Props {
  heading: string
  subheading: string
  trip: BasicTrip
}

function CuratedTripPromotion(props: Props) {
  const { heading, subheading, trip } = props

  return (
    <Group
      direction="vertical"
      gap={24}
      smDirection="horizontal"
      smGap={40}
      smVerticalAlign="center"
    >
      <TextSection>
        <Heading variant="heading4" colour="neutral-one">
          {heading}
        </Heading>
        <BodyText variant="medium" colour="neutral-one">
          {subheading}
        </BodyText>
      </TextSection>
      <TileSection>
        <TripTile trip={trip} />
      </TileSection>
    </Group>
  )
}

export default React.memo(CuratedTripPromotion)
